import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaPhone, FaEnvelope, FaLinkedin, FaYoutube } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { Col, Row, Container } from 'react-bootstrap';
import api from '../api';

const Footer = () => {
  const [settings, setSettings] = useState({
    site_name: 'Kobithan Garments',
    email: 'office@kobithangarments.com',
    phone: '0703533536',
    facebook_url: '',
    instagram_url: '',
    twitter_url: '',
    linkedin_url: '',
    youtube_url: '',
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const { data } = await api.get('/api/settings');
        if (data) setSettings(data);
      } catch (err) {
        console.error('Error fetching site settings', err);
      }
    };
    fetchSettings();
  }, []);

  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="bg-white text-[#1a202c] pt-10 px-6 md:px-20 lg:px-32 overflow-hidden mt-4 pb-8"
      id="footer"
      style={{
        backgroundImage: 'url("https://www.transparenttextures.com/patterns/graphy-light.png")',
        backgroundAttachment: 'fixed'
      }}
    >
      <Container>
        <Row className="align-items-start">
          {/* Column 1: Navigation Links */}
          <Col xs={6} md={3} className="mb-4">
            <ul className="flex flex-col gap-2 list-unstyled text-sm font-bold">
              <li><Link to="/" className="text-[#1a202c] hover:text-customRed no-underline">Home</Link></li>
              <li><Link to="/about" className="text-[#1a202c] hover:text-customRed no-underline">About Us</Link></li>
              <li><Link to="/contact" className="text-[#1a202c] hover:text-customRed no-underline">Contact Us</Link></li>
              <li><Link to="/products" className="text-[#1a202c] hover:text-customRed no-underline">Products</Link></li>
              <li><Link to="/career" className="text-[#1a202c] hover:text-customRed no-underline">Careers</Link></li>
              <li><Link to="/help" className="text-[#1a202c] hover:text-customRed no-underline">Help</Link></li>
            </ul>
          </Col>

          {/* Column 2: Social Media Icons */}
          <Col xs={6} md={3} className="mb-4 flex justify-center md:justify-start pt-1">
            <div className="flex gap-4 flex-wrap">
              {settings.facebook_url && (
                <a href={settings.facebook_url} target="_blank" rel="noopener noreferrer" className="text-[#1a202c] hover:text-customRed transition duration-300 text-xl">
                  <FaFacebook />
                </a>
              )}
              {settings.twitter_url && (
                <a href={settings.twitter_url} target="_blank" rel="noopener noreferrer" className="text-[#1a202c] hover:text-customRed transition duration-300 text-xl">
                  <FaXTwitter />
                </a>
              )}
              {settings.instagram_url && (
                <a href={settings.instagram_url} target="_blank" rel="noopener noreferrer" className="text-[#1a202c] hover:text-customRed transition duration-300 text-xl">
                  <FaInstagram />
                </a>
              )}
              {settings.linkedin_url && (
                <a href={settings.linkedin_url} target="_blank" rel="noopener noreferrer" className="text-[#1a202c] hover:text-customRed transition duration-300 text-xl">
                  <FaLinkedin />
                </a>
              )}
              {settings.youtube_url && (
                <a href={settings.youtube_url} target="_blank" rel="noopener noreferrer" className="text-[#1a202c] hover:text-customRed transition duration-300 text-xl">
                  <FaYoutube />
                </a>
              )}
            </div>
          </Col>

          {/* Column 3: Email */}
          <Col xs={12} md={3} className="mb-4 flex md:justify-center pt-1">
            {settings.email && (
              <div className="flex items-center gap-2 text-sm">
                <FaEnvelope className="text-[#1a202c]" />
                <a href={`mailto:${settings.email}`} className="text-[#1a202c] hover:text-customRed no-underline">
                  {settings.email}
                </a>
              </div>
            )}
          </Col>

          {/* Column 4: Phone */}
          <Col xs={12} md={3} className="mb-4 flex md:justify-end pt-1">
            {settings.phone && (
              <div className="flex items-center gap-2 text-sm">
                <FaPhone className="text-[#1a202c] transform -rotate-90" />
                <a href={`tel:${settings.phone}`} className="text-[#1a202c] hover:text-customRed no-underline">
                  {settings.phone}
                </a>
              </div>
            )}
          </Col>
        </Row>

        {/* Footer Bottom Border and Branding */}
        <div className="border-t border-gray-200 mt-8 pt-4 mb-4">
          <Row>
             <Col className="text-center text-xs text-gray-400">
               © {currentYear} {settings.site_name} (Pvt) Ltd. All rights reserved.
             </Col>
          </Row>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
